// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PatientModelResponse {
    static getAttributeTypeMap() {
        return PatientModelResponse.attributeTypeMap;
    }
}
PatientModelResponse.discriminator = undefined;
PatientModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PatientModel"
    }
];
//# sourceMappingURL=patientModelResponse.js.map